import { ModuleRelatedToolBarViewModel } from './related/module-related.tool-bar-view-model';

export class ModuleToolBarViewModel extends ModuleRelatedToolBarViewModel {
}
